export const LocalStorageKeys = {
  lastSyncedDate: "userArticleReadingHistoryLastUpdate",
  pending: "userNewArticleReadingHistory",
  synced: "userArticleReadingHistory"
};
export const ReadingHistoryItemSize = 50;